<template>
  <div class="container-login">
    <v-form ref="form" autocomplete="off">
      <v-container fluid ma-0 pa-0 style="width: 100% !important; max-width: 100% !important">
        <div class="mx-auto" style="max-width: 500px;">
          <v-row>
            <v-col cols="12" class="text-center text-4xl font-semibold">
              <font class="textcolor1--text">SmartLink </font
              ><font class="light-blue--text textcolor2--text">Platform</font>
            </v-col>
            <v-col cols="12"><div style="height: 30px;"></div></v-col>
            <v-col cols="12" class="text-center text-3xl font-semibold textcolor1--text blue--text">
              Change Password
            </v-col>
            <v-col cols="12" class="text-center textcolor2--text">
              {{
                reason === 'neverset'
                  ? 'This is your first login. Please set a new password to continue.'
                  : 'Your password has expired (90 days). Please reset your password to continue.'
              }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                ref="oldPwd"
                v-model="pwdChg.oldPwd"
                type="password"
                placeholder="Current Password"
                :rules="rules.oldPwd"
                autocomplete="off"
                required
                dense
                solo
                height="40"
                class="account-field"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-inline-flex">
              <v-text-field
                ref="newPwd"
                v-model="pwdChg.newPwd"
                type="password"
                placeholder="New Password"
                :rules="newPwdRules"
                autocomplete="new-password"
                required
                dense
                solo
                height="40"
                class="account-field"
                :maxlength="20"
              ></v-text-field>
              <v-tooltip top :max-width="tooltipWidth" style="questionToolTip">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-icon class="btn-tooltip-pw pt-3 pl-1">
                      far fa-question-circle
                    </v-icon>
                  </div>
                </template>
                <span v-html="$t('msg.users.questionIconTooltip')"> </span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                ref="newPwdCfm"
                v-model="pwdChg.newPwdCfm"
                type="password"
                placeholder="Confirm New Password"
                :rules="newPwdCfmRules"
                required
                dense
                solo
                height="40"
                class="account-field"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn block x-large color="primary" :disabled="isSubmitDisabled" @click="save()">
                Change Password
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <dialogWindow
        ref="ChangePasswordDialog"
        :info="checkDialogTitle"
        size="max"
        :detail="checkDialogInfo"
        :color="checkDialogColor"
        @select-ok="closeDialog()"
      >
      </dialogWindow>
    </v-form>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    dialogWindow,
  },

  data: () => ({
    pwdChg: {
      oldPwd: '',
      newPwd: '',
      newPwdCfm: '',
    },
    rules: {
      oldPwd: [(v) => !!v || 'Current Password is required'],
    },
    formHasErrors: false,
    checkDialogColor: 'success',
    checkDialogTitle: '',
    checkDialogInfo: '',
    tooltipWidth: 300,
  }),

  computed: {
    usrId() {
      return this.$route.params.usrId;
    },
    reason() {
      return this.$route.query.reason;
    },
    samePwdError() {
      return (
        !!this.pwdChg.oldPwd &&
        !!this.pwdChg.newPwd &&
        this.pwdChg.oldPwd === this.pwdChg.newPwd
      );
    },
    pwdCfmMismatch() {
      return !!this.pwdChg.newPwdCfm && this.pwdChg.newPwd !== this.pwdChg.newPwdCfm;
    },
    newPwdRules() {
      return [
        this.validationUtils.passwordRules,
        (v) => v !== this.pwdChg.oldPwd || 'New Password must be different from Current Password',
      ];
    },
    newPwdCfmRules() {
      return [
        (v) => !!v || 'Confirm Password is required',
        (v) => v === this.pwdChg.newPwd || 'Password is different. Please check input password!',
      ];
    },
    isSubmitDisabled() {
      return this.samePwdError || this.pwdCfmMismatch;
    },
  },

  mounted() {
    setTimeout(() => {
      this.$refs.oldPwd.focus();
    }, 300);
  },

  methods: {
    save() {
      this.formHasErrors = false;

      Object.keys(this.pwdChg).forEach((key) => {
        if (this.pwdChg[key] === '') {
          this.formHasErrors = true;
          this.$refs[key].validate(true);
        }
      });

      if (this.formHasErrors || this.isSubmitDisabled) {
        return;
      }

      this.$store
        .dispatch('membership/changeExpiredPassword', {
          usrId: this.usrId,
          oldPwd: this.pwdChg.oldPwd,
          newPwd: this.pwdChg.newPwd,
        })
        .then(() => {
          this.checkDialogColor = 'success';
          this.checkDialogTitle = 'Password Changed';
          this.checkDialogInfo = 'Your password has been changed. Please sign in again.';
          this.$refs.ChangePasswordDialog.dialog = true;
        })
        .catch(() => {
          this.checkDialogColor = 'error';
          this.checkDialogTitle = 'Error';
          this.checkDialogInfo = 'Current Password is incorrect. Please try again.';
          this.$refs.ChangePasswordDialog.dialog = true;
        });
    },

    closeDialog() {
      if (this.checkDialogColor === 'success') {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style>
.container-login .v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
  height: auto !important;
}
</style>
